module.exports = __webpack_public_path__ + "static/img/esales-2.e48d9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zsy_esales/esales-2.png
// module id = 240
// module chunks = 6